export const saveToken = (token: string) => localStorage.setItem('token', token);

export const saveRefresh = (refresh: string) => localStorage.setItem('refresh', refresh);

export const saveUsername = (userName: string) => localStorage.setItem('user_name', userName);

export const getToken = () => localStorage.getItem('token');

export const getRefresh = () => localStorage.getItem('refresh');

export const getUserName = () => localStorage.getItem('user_name');

export const isAuthenticated = () => !!getToken();

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user_name');
}
